import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Divider,
  Grid,
  Paper
} from '@mui/material';
import {
  PointOfSale as PosIcon,
  AccountBalanceWallet as WalletIcon,
  CheckCircle as CheckIcon,
  Error as ErrorIcon,
  Close as CloseIcon,
  Receipt as ReceiptIcon,
  AttachMoney as MoneyIcon
} from '@mui/icons-material';

const currencyRD = (v) =>
  new Intl.NumberFormat("es-DO", { style: "currency", currency: "DOP" }).format(v);

export default function CerrarTurnoDialog({ open, onClose, onShiftClosed, currentShift }) {
  const [finalCash, setFinalCash] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [shiftSummary, setShiftSummary] = useState(null);
  const [shiftSummaryCargosEfectivo, setShiftSummaryCargosEfectivo] = useState(null);
  const [shiftSummaryCargosOtros, setShiftSummaryCargosOtros] = useState(null);
  const [categoriasCargos, setCategoriasCargos] = useState(null);
  const [shiftSummaryCargosCantidad, setShiftSummaryCargosCantidad] = useState(null);
  const [shiftSummaryCargosEfectivoVentas, setShiftSummaryCargosEfectivoVentas] = useState(null);
  const [shiftSummaryCargosOtrosVentas, setShiftSummaryCargosOtrosVentas] = useState(null);
  const [shiftSummaryCargosEfectivoIniciales, setShiftSummaryCargosEfectivoIniciales] = useState(null);
  const [shiftSummaryCargosOtrosIniciales, setShiftSummaryCargosOtrosIniciales] = useState(null);
  const [shiftSummaryCargosEfectivoPagosPrestamos, setShiftSummaryCargosEfectivoPagosPrestamos] = useState(null);
  const [shiftSummaryCargosOtrosPagosPrestamos, setShiftSummaryCargosOtrosPagosPrestamos] = useState(null); 
  useEffect(() => {
    if (open && currentShift) {
      fetchShiftSummary();
      fetchCategoriasCargos();
    }
  }, [open, currentShift]);

  useEffect(() => {
    if (shiftSummary && currentShift) {
      // Calculate expected cash based on initial amount and all cash payments
      const expectedCash = 
        (currentShift.monto_inicial || 0) + 
        (shiftSummary.total_efectivo || 0) + 
        (shiftSummary.total_efectivo_prestamos || 0) + 
        (shiftSummary.total_efectivo_iniciales || 0) + 
        (shiftSummary.total_efectivo_matriculas || 0);
    }
  }, [shiftSummary, currentShift]);

  const fetchShiftSummary = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pos/shifts/summary?id_usuario=${localStorage.getItem('id')}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      
      const result = await response.json();
      if (result.success) {
          setShiftSummary(result.summary[0]);
        setShiftSummaryCargosEfectivoVentas(result.summary_cargos_efectivo_ventas);
        setShiftSummaryCargosOtrosVentas(result.summary_cargos_otros_ventas);
        setShiftSummaryCargosEfectivoIniciales(result.summary_cargos_efectivo_iniciales);
        setShiftSummaryCargosOtrosIniciales(result.summary_cargos_otros_iniciales);
        setShiftSummaryCargosEfectivoPagosPrestamos(result.summary_cargos_efectivo_pagos_prestamos);
        setShiftSummaryCargosOtrosPagosPrestamos(result.summary_cargos_otros_pagos_prestamos);
        setShiftSummaryCargosEfectivo(result.summary_cargos_efectivo);
        setShiftSummaryCargosOtros(result.summary_cargos_otros);
        setShiftSummaryCargosCantidad(result.summary_cargos_cantidad);
      }
    } catch (error) {
      console.error('Error fetching shift summary:', error);
    }
  };

  const fetchCategoriasCargos = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/categorias_cargos/company/${localStorage.getItem('idcompany')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      }
    });

    const data = await response.json();
    setCategoriasCargos(data);
  };

  const handleSubmit = async () => {
    if (!finalCash || parseFloat(finalCash) < 0) {
      setError('Por favor ingrese un monto válido para el cierre de caja');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const closeData = {
        id_usuario: localStorage.getItem('id'),
        monto_final: parseFloat(finalCash),
        observaciones: ''
      };

      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pos/shifts/close`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(closeData)
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          onShiftClosed(result.shift_summary);
          handleClose();
        }, 2000);
      } else {
        setError(result.message || 'Error al cerrar el turno');
      }
    } catch (error) {
      console.error('Error closing shift:', error);
      setError('Error de conexión. Intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFinalCash('');
      setError('');
      setSuccess(false);
      setShiftSummary(null);
      setShiftSummaryCargosEfectivo(null);
      setShiftSummaryCargosOtros(null);
      setShiftSummaryCargosCantidad(null);
      setShiftSummaryCargosEfectivoVentas(null);
      setShiftSummaryCargosOtrosVentas(null);
      setShiftSummaryCargosEfectivoIniciales(null);
      setShiftSummaryCargosOtrosIniciales(null);
      setShiftSummaryCargosEfectivoPagosPrestamos(null);
      setShiftSummaryCargosOtrosPagosPrestamos(null);
      onClose();
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !loading) {
      handleSubmit();
    }
  };

  const calculateDifference = () => {
    if (!currentShift || !finalCash || !shiftSummary) return 0;
    const expectedCash = 
      (currentShift.monto_inicial || 0) + 
      (shiftSummary.total_efectivo || 0) + 
      (shiftSummary.total_efectivo_prestamos || 0) + 
      (shiftSummary.total_efectivo_iniciales || 0) + 
      (shiftSummary.total_efectivo_matriculas || 0);
    return parseFloat(finalCash) - expectedCash;
  };

  const difference = calculateDifference();
  const isDifference = Math.abs(difference) > 0.01; // Allow for small rounding differences

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          height: '80vh',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <CloseIcon color="primary" sx={{ fontSize: 28 }} />
          <Box>
            <Typography variant="h6" fontWeight={600}>
              Cerrar Turno de Caja
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Cuente el efectivo y confirme el cierre del turno
            </Typography>
          </Box>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ 
        pt: 2, 
        flex: 1, 
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '4px',
          '&:hover': {
            background: '#a8a8a8',
          },
        },
      }}>
        {success ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <CheckIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
            <Typography variant="h6" color="success.main" gutterBottom>
              ¡Turno Cerrado Exitosamente!
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Resumen del turno guardado correctamente
            </Typography>
          </Box>
        ) : (
          <Stack spacing={3}>
            {error && (
              <Alert severity="error" icon={<ErrorIcon />}>
                {error}
              </Alert>
            )}

            {/* Shift Information */}
            <Paper sx={{ p: 3, bgcolor: 'grey.50' }}>
              <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                <WalletIcon color="primary" />
                <Typography variant="h6" fontWeight={600}>
                  Información del Turno
                </Typography>
              </Stack>
              
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    Usuario
                  </Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {localStorage.getItem('nombre') || 'Usuario'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    Sucursal
                  </Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {localStorage.getItem('nombre_sucursal') || 'Sucursal'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    Fecha de Apertura
                  </Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {currentShift?.fecha_apertura ? new Date(currentShift.fecha_apertura).toLocaleString('es-DO') : 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="text.secondary">
                    Monto Inicial
                  </Typography>
                  <Typography variant="body1" fontWeight={500} color="primary.main">
                    {currencyRD(currentShift?.monto_inicial || 0)}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>

            {/* Sales Summary */}
            {shiftSummary && (
              <Paper sx={{ p: 3, bgcolor: 'blue.50' }}>
                <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                  <ReceiptIcon color="primary" />
                  <Typography variant="h6" fontWeight={600}>
                    Resumen de Ventas
                  </Typography>
                </Stack>
                
                <Grid container spacing={0}>
                  <Grid item size={3}>
                    <Typography variant="body2" color="text.secondary">
                      Total Ventas
                    </Typography>
                    <Typography variant="h6" fontWeight={600}>
                      {shiftSummaryCargosEfectivoVentas.length || 0}
                    </Typography>
                  </Grid>
                  <Grid item size={3}>
                    <Typography variant="body2" color="text.secondary">
                      Monto Total
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="success.main">
                      {currencyRD(shiftSummaryCargosEfectivoVentas.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                  <Grid item size={3}>
                    <Typography variant="body2" color="text.secondary">
                      Ventas en Efectivo
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="info.main">
                      {currencyRD(shiftSummaryCargosEfectivoVentas.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                  <Grid item size={3}>
                    <Typography variant="body2" color="text.secondary">
                      Otras Formas de Pago
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="warning.main">
                      {currencyRD((shiftSummaryCargosEfectivoVentas.reduce((acc, cargo) => acc + cargo.total_efectivo, 0)) - (shiftSummaryCargosEfectivoVentas.reduce((acc, cargo) => acc + cargo.total_efectivo, 0)))}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}

            {/* Loans Payments Summary */}
            {shiftSummary && (
              <Paper sx={{ p: 3, bgcolor: 'green.50' }}>
                <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                  <ReceiptIcon color="success" />
                  <Typography variant="h6" fontWeight={600}>
                    Pagos de Préstamos
                  </Typography>
                </Stack>
                
                <Grid container spacing={0}>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      Total Pagos
                    </Typography>
                    <Typography variant="h6" fontWeight={600}>
                      {shiftSummaryCargosEfectivoPagosPrestamos.length || 0}
                    </Typography>
                  </Grid>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      Monto Total
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="success.main">
                      {currencyRD(shiftSummaryCargosEfectivoPagosPrestamos.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      En Efectivo
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="info.main">
                      {currencyRD(shiftSummaryCargosEfectivoPagosPrestamos.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}

            {/* Initials Summary */}
            {shiftSummary && (
              <Paper sx={{ p: 3, bgcolor: 'orange.50' }}>
                <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                  <ReceiptIcon color="warning" />
                  <Typography variant="h6" fontWeight={600}>
                    Pagos de Iniciales
                  </Typography>
                </Stack>
                
                <Grid container spacing={0}>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      Total Iniciales
                    </Typography>
                    <Typography variant="h6" fontWeight={600}>
                      {shiftSummaryCargosEfectivoIniciales.length || 0}
                    </Typography>
                  </Grid>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      Monto Total
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="success.main">
                      {currencyRD(shiftSummaryCargosEfectivoIniciales.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      En Efectivo
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="info.main">
                      {currencyRD(shiftSummaryCargosEfectivoIniciales.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}

            {/* Cargos Summary */}
            {shiftSummary && categoriasCargos && (
              <>
                {categoriasCargos.map((categoria) => (
              <Paper sx={{ p: 3, bgcolor: 'purple.50' }}>

                <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                  <ReceiptIcon color="secondary" />
                  <Typography variant="h6" fontWeight={600}>
                    Pagos de {categoria.nombre}
                  </Typography>
                </Stack>
                
                <Grid container spacing={0}>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      Total {categoria.nombre}
                    </Typography>
                    <Typography variant="h6" fontWeight={600}>
                      {shiftSummaryCargosCantidad.find((cargo) => cargo.cargo === categoria.id)?.cantidad || 0}
                    </Typography>
                  </Grid>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      Monto Total
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="success.main">
                      {currencyRD((shiftSummaryCargosEfectivo.find((cargo) => cargo.cargo === categoria.id)?.total_efectivo||0) + (shiftSummaryCargosOtros.find((cargo) => cargo.cargo === categoria.id)?.total_otros || 0))}
                    </Typography>
                  </Grid>
                  <Grid item size={4}>
                    <Typography variant="body2" color="text.secondary">
                      En Efectivo
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="info.main">
                      {currencyRD( shiftSummaryCargosEfectivo.find((cargo) => cargo.cargo === categoria.id)?.total_efectivo || 0)}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
              ))}
              </>
            )}

            {/* Total Cash Summary */}
            {shiftSummary && (
              <Paper sx={{ p: 3, bgcolor: 'grey.100', border: '2px solid', borderColor: 'primary.main' }}>
                <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                  <MoneyIcon color="primary" />
                  <Typography variant="h6" fontWeight={600}>
                    Resumen Total de Efectivo
                  </Typography>
                </Stack>
                
                <Grid container spacing={0}>
                  <Grid item size={3}>
                    <Typography variant="body2" color="text.secondary">
                      Ventas
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="info.main">
                      {currencyRD(shiftSummaryCargosEfectivoVentas.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                  <Grid item size={3}>
                    <Typography variant="body2" color="text.secondary">
                      Préstamos
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="success.main">
                      {currencyRD(shiftSummaryCargosEfectivoPagosPrestamos.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                  <Grid item size={3}>
                    <Typography variant="body2" color="text.secondary">
                      Iniciales
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="warning.main">
                      {currencyRD(shiftSummaryCargosEfectivoIniciales.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))}
                    </Typography>
                  </Grid>
                  {categoriasCargos && (
                    <>
                      {categoriasCargos.map((categoria) => (
                        <Grid item size={3}>
                          <Typography variant="body2" color="text.secondary">
                            {categoria.nombre}
                          </Typography>
                          <Typography variant="h6" fontWeight={600} color="secondary.main">
                            {currencyRD(shiftSummaryCargosEfectivo.find((cargo) => cargo.cargo === categoria.id)?.total_efectivo || 0)}
                          </Typography>
                        </Grid>
                      ))}
                    </>
                  )}
                  <Grid item size={12} mt={2}>
                    <Typography variant="body2" color="text.secondary">
                      Total Efectivo Esperado (Incluyendo fondo de apertura)
                    </Typography>
                    <Typography variant="h5" fontWeight={700} color="primary.main">
                      {currencyRD(
                        parseFloat(currentShift?.monto_inicial || 0) + 
                        parseFloat(shiftSummaryCargosEfectivoVentas.reduce((acc, cargo) => acc + cargo.total_efectivo, 0)) + 
                        parseFloat(shiftSummaryCargosEfectivoPagosPrestamos.reduce((acc, cargo) => acc + cargo.total_efectivo, 0)) + 
                        parseFloat(shiftSummaryCargosEfectivoIniciales.reduce((acc, cargo) => acc + cargo.total_efectivo, 0)) + 
                        parseFloat(shiftSummaryCargosEfectivo.reduce((acc, cargo) => acc + cargo.total_efectivo, 0))
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}

            <Divider />

            {/* Final Cash Count */}
            <Box>
              <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                <MoneyIcon color="primary" />
                <Typography variant="h6" fontWeight={600}>
                  Conteo Final de Efectivo
                </Typography>
              </Stack>
              
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Cuente todo el efectivo disponible en la caja e ingrese el monto total
              </Typography>
              
              <TextField
                fullWidth
                placeholder="0.00"
                type="number"
                value={finalCash}
                onChange={(e) => setFinalCash(e.target.value)}
                onKeyPress={handleKeyPress}
                InputProps={{
                  startAdornment: <Typography sx={{ mr: 1 }}>RD$</Typography>,
                  inputProps: { 
                    min: 0,
                    step: 0.01
                  }
                }}
                disabled={loading}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '1.1rem',
                    fontWeight: 500
                  }
                }}
              />
              
              {finalCash && (
                <Stack spacing={1} sx={{ mt: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Monto contado: {currencyRD(parseFloat(finalCash) || 0)}
                  </Typography>
                  
                  {isDifference && (
                    <Alert 
                      severity={difference > 0 ? "warning" : "error"}
                      sx={{ mt: 1 }}
                    >
                      <Typography variant="body2">
                        <strong>Diferencia detectada:</strong> {currencyRD(difference)}
                        {difference > 0 ? ' (Sobrante)' : ' (Faltante)'}
                      </Typography>
                    </Alert>
                  )}
                </Stack>
              )}
            </Box>

            <Alert severity="info">
              <Typography variant="body2">
                <strong>Importante:</strong> Asegúrese de contar todo el efectivo antes de cerrar el turno. 
                Cualquier diferencia será registrada en el sistema.
              </Typography>
            </Alert>
          </Stack>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        {!success && (
          <>
            <Button 
              onClick={handleClose} 
              disabled={loading}
              sx={{ minWidth: 100 }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleSubmit}
              disabled={loading || !finalCash}
              startIcon={loading ? <CircularProgress size={16} /> : <CloseIcon />}
              sx={{ 
                minWidth: 120,
                fontWeight: 600
              }}
            >
              {loading ? 'Cerrando...' : 'Cerrar Turno'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
